import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetricsBrightnessFaceup = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M22.5 0h3v5.959h-3zm0 42.041h3V48h-3zM0 22.5h5.958v3H0zm42.042 0H48v3h-5.958zM5.97 8.09l2.12-2.122 4.214 4.214-2.121 2.122zm29.726 29.727 2.122-2.121 4.213 4.214-2.121 2.121zM5.969 39.91l4.214-4.214 2.121 2.121-4.214 4.214zm29.728-29.728 4.214-4.214 2.121 2.122-4.214 4.213zm-2.166 4.287L24 10.521l-9.531 3.948L10.521 24l3.948 9.531L24 37.479l9.531-3.948L37.479 24zM16.765 31.235l-3-7.235 3-7.235 7.235-3v5.707L20.8 20.8 19.475 24l1.325 3.2 3.2 1.325v-9.05l3.2 1.325 1.325 3.2-1.325 3.2-3.2 1.325v5.707z" })
});
export default SvgMetricsBrightnessFaceup;
